import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexRow, Gap } from 'ui-components/components/flex';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import { useScanVerificationContext } from './scan-verification-context-provider';

export const ScanToVerifyButtons = memo(() => {
  const {
    isVerified,
    isSubmitting,
    isInVerificationMode,
    openVerificationMode,
    closeVerificationMode,
    requireManualMarkingAsVerified,
    submitVerification,
  } = useScanVerificationContext();

  return (
    <FlexRow gap={Gap.Space8}>
      <Button
        disabled={isSubmitting}
        onClick={isInVerificationMode ? closeVerificationMode : openVerificationMode}
        theme={THEME_CONSTANTS.tertiary}
      >
        <FormattedMessage {...(isInVerificationMode ? messages.exitScan : messages.startScan)} />
      </Button>
      {requireManualMarkingAsVerified && isInVerificationMode ? (
        <Button disabled={isSubmitting || !isVerified} onClick={submitVerification} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage {...messages.markOrderAsVerified} />
        </Button>
      ) : null}
    </FlexRow>
  );
});
